// Détection runtime du mode « landing publique » (domaine de production junago.io).
// Sur ce domaine, l'app n'expose que la landing + les pages légales.
// En Preview / local, l'app complète fonctionne normalement.
export const LANDING_HOSTS = ["junago.io", "www.junago.io"];

export function isLandingMode() {
  if (typeof window === "undefined") return false;
  try {
    // Un bêta-testeur authentifié accède à son espace Junago complet (pas la landing).
    if (sessionStorage.getItem("cm_token")) return false;
    const host = window.location.hostname;
    if (LANDING_HOSTS.includes(host)) return true;
    if (process.env.REACT_APP_SHOW_LANDING === "true") return true;
    const params = new URLSearchParams(window.location.search);
    if (params.get("preview_landing") === "1") return true;
  } catch (e) { /* noop */ }
  return false;
}
